<ion-content class="ion-padding">
  <curbnturf-new-password></curbnturf-new-password>
</ion-content>
